<template>
  <div>
    <right-panel class="float-right" id="sidebar-new-department" width="600px" icon="" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form @onAdminChanged="onAdminChanged" />
      </div>
    </right-panel>

    <!-- Begin : Inventory -->
    <template>
      <right-panel class="float-right" id="sidebar-department-inventory" width="1400px" icon="" @hidden="bulkUpdateRightPanelClosed">
        <!-- TKP-128: girilmiş kayıtlar + toplu güncelleme. TKP-182 md.82: iki sekme panelin kendisinde (TKP-173) — buradaki dış sekme
             çubuğu aynı iki başlığı ikinci kez çiziyordu, kalktı. -->
        <HierarchyInventoryView v-if="selectedBox" :department="selectedBox" :reload="inventoryReload" data-test="department-inventory-view" />
      </right-panel>
      <!-- TKP-178 md.48: ilgili kişileri birimin tüm süreçlerindeki verilerden kaldır / değiştir -->
      <right-panel class="float-right" id="sidebar-department-bulk-remove" width="700px" icon="">
        <div class="pl-5 pr-5" v-if="selectedBox">
          <BulkRemoveForm :department="selectedBox" />
        </div>
      </right-panel>
    </template>
    <!-- End : Inventory -->

    <div class="ds-card">
      <div class="ds-card--title justify-content-between">
        <span>
          <i class="iconoir-center-align align-middle mr-3" style="color: #383A55; font-size: 1.5rem !important;"></i>
          {{ $t("department.organization-departments") }}
        </span>

      </div>
      <div>
        <small class="text-muted d-block mb-2">{{ $t("department.process-allowed-list-hint") }}</small>
        <div class="search2  mb-4" style=" width: 18.50rem;">
          <div class="search2--icon"><i class="iconoir-search"></i></div>
          <input class="search2--input" type="text" :placeholder="$t('common.search')" v-model="nameFilter" />
        </div>
      </div>

      <content-loading v-if="isLoading" />
      <div v-else-if="pagination" class="d-flex" style="gap: 1.25rem;flex-wrap: wrap;">
        <div v-for="item in pagination.docs" :key="item._id" :id="'popover-target-' + item._id" class="ds-card--item" :class="selectedBoxStyle(item)" @click="selectBox(item)">
          <div class="actions d-flex justify-content-end p-2" style="top:0">
            <div class="action" @click="redirectToRelatedFiles(item)" v-on:click.stop v-b-tooltip.hover :title="$t('file-manager.view-related-files')">
              <i class="iconoir-page"></i>
            </div>
          </div>
          <div class="text">
            {{ item.name | translate }}
            <draft-badge entity-type="DEPARTMENT" :entity-id="item._id" />
            <!-- TKP-27 / K3: üst birim -->
            <div v-if="item.parent" class="small mt-1" :class="selectedBox && selectedBox._id == item._id ? 'text-white-50' : 'text-muted'" v-b-tooltip.hover :title="$t('department.parent')">
              <i class="bx bx-up-arrow-alt"></i> {{ item.parent.name | translate }}
            </div>
          </div>
          <!-- TKP-114: yazma eylemleri yalnız düzenleyebilene. Kural backend'inkiyle aynı (DepartmentAuthority.canEdit):
               DEPARTMENT_EDIT yeteneği VEYA o birimin yetkilisi olmak. Eskiden üçü de koşulsuzdu; Risk Yöneticisi ve
               İç Kontrol düğmeleri görüp basınca 403 alıyordu. -->
          <div class="actions d-flex justify-content-center">
            <div class="action" v-if="canEdit(item)" @click="deleteById(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.delete')">
              <i class="iconoir-trash"></i>
            </div>
            <div class="action" v-if="canEdit(item)" @click="markAsComplete(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.completed')">
              <i :class="item.completed ? 'iconoir-check-circle' : 'iconoir-circle'"></i>
            </div>
            <div class="action" v-if="canEdit(item)" @click="edit(item)" v-on:click.stop v-b-toggle="'sidebar-edit-organization-department'" v-b-tooltip.hover :title="$t('common.edit')">
              <i class="iconoir-edit-pencil"></i>
            </div>
            <div class="action" @click="showInventoryPanel(item)" v-on:click.stop v-b-tooltip.hover :title="$t('inventory.filter.inventory-features')">
              <i class="iconoir-network-right"></i>
            </div>
            <!-- TKP-242 q.4: onay açıkken de görünür — form kaldırma/değiştirmeyi taslağa yazar (arka planda) -->
            <div class="action" data-test="bulk-remove-action" @click="showBulkRemovePanel(item)" v-on:click.stop v-b-tooltip.hover :title="$t('process-data.bulk-remove.action-department')">
              <i class="iconoir-user-xmark"></i>
            </div>
          </div>

          <b-popover :target="'popover-target-' + item._id" triggers="hover" placement="bottom" variant="secondary">
            <template #title> {{ $t("department.admins") }}</template>
            <table>
              <tr v-for="admin in item.admins" :key="'department-admin' + admin._id">
                <td><letter-avatar :name="admin.account.name" :image="admin.account.avatar" variant="secondary" /></td>
                <td class="text-center">{{ admin.account.name }}</td>
              </tr>
              <tr v-if="!item.admins || item.admins.length < 1">
                <span>
                  <b>
                    {{ $t("department.no-admin") }}
                  </b>
                </span>
              </tr>
            </table>
          </b-popover>
        </div>

        <!-- TKP-189: taslağımdaki yeni birimler — seçilebilir gölge kart (altına süreç eklenebilsin); silme/düzenleme/envanter eylemi yok -->
        <div v-for="item in shadowDepartments" :key="'shadow-' + item._id" class="ds-card--item" style="opacity: .85; border-style: dashed;" :class="selectedBoxStyle(item)" data-test="shadow-department" @click="selectBox(item)">
          <div class="text">
            {{ item.name | translate }}
            <b-badge variant="info" class="ml-1"><i class="bx bx-edit"></i> {{ $t(draftBadgeKey(item)) }} · {{ $t("approval.new-record") }}</b-badge>
            <div v-if="item.parent" class="small mt-1" :class="selectedBox && selectedBox._id == item._id ? 'text-white-50' : 'text-muted'" v-b-tooltip.hover :title="$t('department.parent')">
              <i class="bx bx-up-arrow-alt"></i> {{ item.parent.name | translate }}
            </div>
          </div>
        </div>

        <div class="ds-card--item2" v-b-toggle="'sidebar-new-department'">
          <i class="iconoir-plus" style="font-size: 1.75rem;"></i>
        </div>
      </div>

      <!-- Begin: Pagination -->

      <div v-if="pagination" class="row mt-4">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
          </ul>
        </div>
      </div>
      <!-- End: Pagination -->
    </div>
  </div>
</template>

<script>
import DraftBadge from "@/modules/approval/draft-badge"; // TKP-104
import { completeBlocked } from "@/modules/approval/approval"; // TKP-241 p.6
import { canEditDepartment } from "@modules/entity/department-permissions";
import HierarchyInventoryView from "@modules/inventory/component/hierarchy/hierarchy-inventory-view";
import BulkRemoveForm from "@modules/process-data/component/process-datasubject-bulk-remove-form"; // TKP-178 md.48
import BulkLock from "@/modules/approval/bulk-lock"; // TKP-178 md.48: onay açıkken yalnız onay yetkilisi
import Form from "../../department/organization-department-form";
import { processAllowedQuery } from "@modules/department/process-allowed";
import { draftBadgeKey, shadowDepartmentsOf } from "@/modules/approval/draft-overlay"; // TKP-189

export default {
  mixins: [BulkLock],
  components: { DraftBadge, Form, HierarchyInventoryView, BulkRemoveForm },
  data() {
    return {
      inventoryReload: 0,
      request: {
        options: { page: 1, limit: 17, sort: { name: "asc" } },
        query: processAllowedQuery(), // TKP-64: yalnız süreç eklenebilir birimler
      },
      nameFilter: undefined,
      libraryScopedState: "department",
    };
  },
  computed: {
    // TKP-189: kendi taslağımdaki yeni birimler (süreç eklenebilir olanlar), kutuda gölge kart
    shadowDepartments() {
      return shadowDepartmentsOf((this.$store.getters || {})["approval/drafts"], this.currentAccount && this.currentAccount._id).filter((d) => d.processAllowed);
    },
    pagination() {
      return this.$store.getters["organizationDepartment/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationDepartment/isLoading"];
    },

    /** TKP-114: DEPARTMENT_EDIT yeteneği (rol bazlı). Kalem bazlı yetkililik `canEdit`de eklenir. */
    hasDepartmentEditCapability() {
      return this.currentAccountCan("ENTITY_DEPARTMENT_BOXES__CAN_EDIT");
    },
    selectedBox() {
      return this.$store.getters["entityBoxes/department"];
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    async nameFilter(n, o) {
      this.debounce(() => this.handleNameFilterChanged(n, o));
    },
  },
  mounted() {},
  methods: {
    draftBadgeKey, // TKP-189
    async handleNameFilterChanged(n, o) {
      this.$store.commit("entityBoxes/clear");
      this.$store.commit("organizationDepartment/selectedEntity", undefined);

      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };

        const selectedDepartment = this.$store.getters["entityBoxes/department"];
        if (selectedDepartment) {
          await this.selectBox(selectedDepartment);
        }
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
    redirectToRelatedFiles(item) {
      const url = this.currentProduct ? `/${this.currentProduct.toLowerCase()}/file-manager` : "/organization/file-manager";
      this.$router.push({ path: url, query: { department: item._id, departmentName: item.name?.[this.currentLanguage] } });
    },

    showBulkRemovePanel(item) {
      this.$store.commit("entityBoxes/department", item);
      this.$store.commit("organizationDepartment/selectedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-department-bulk-remove");
    },
    showInventoryPanel(item) {
      this.$store.commit("entityBoxes/department", item);
      this.$store.commit("organizationDepartment/selectedEntity", item);

      this.$store.commit("inventoryFilter/clear");
      this.$store.commit("inventoryFilter/department", item);

      this.inventoryReload++; // TKP-128: panel her açılışta güncel kayıtları çeksin
      this.$root.$emit("bv::toggle::collapse", "sidebar-department-inventory");
    },

    /** Yazma eylemleri: yetki VEYA yetkililik — backend'in `DepartmentAuthority.canEdit` kuralıyla aynı (TKP-114). */
    canEdit(item) {
      return canEditDepartment(item, { hasCapability: this.hasDepartmentEditCapability, accountId: this.currentAccount?._id });
    },
    selectedBoxStyle(item) {
      let style = "";
      if (this.selectedBox?._id == item._id) {
        style = "bg-main text-white";
      } else if (item.completed) {
        style += " completed";
      }
      return style;
    },

    async paginate() {
      await this.$store.dispatch("organizationDepartment/paginate", this.request);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationDepartment/delete", item._id);
        this.paginate();

        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    async markAsComplete(item) {
      // TKP-241 p.6: taslaktaki kayıt tamamlandı işaretlenemez; değilse taslağa yazılmadan doğrudan işaretlenir
      if (completeBlocked((this.$store.getters || {})["approval/drafts"], "DEPARTMENT", item, this.currentAccount && this.currentAccount._id)) {
        this.$toast.warning(this.$t("approval.complete-has-drafts"));
        return;
      }
      try {
        await this.$store.dispatch("organizationDepartment/markAsComplete", item._id);
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    edit(item) {
      this.$store.commit("organizationDepartment/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-department");
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.commit("organizationDepartment/editedEntity");
      this.$store.commit("organizationDepartment/copingEntity");
      // this.$store.dispatch("organizationDepartment/resetForm");
    },
    bulkUpdateRightPanelClosed() {
      this.$store.commit("inventoryFilter/clear");
    },

    async selectBox(item) {
      return this.$store.dispatch("entityBoxes/selectDepartment", item);
    },

    async onAdminChanged() {
      const selectedDepartment = this.$store.getters["entityBoxes/department"];

      await this.selectBox(selectedDepartment); //ikikere çağırılmasının nedeni toggle yapmak
      await this.selectBox(selectedDepartment);
    },
    copyToForm(item) {
      this.$store.commit(`organizationDepartment/copingEntity`, { ...item, libraryItem: item, _id: undefined });
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-department");
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../organization-entities-view.scss");
</style>
